
  function filterPages(searchTerm) {
    // Convert to lowercase for case-insensitive matching
    console.log('searchTerm:  '+searchTerm);
    const term = searchTerm.toLowerCase();

    document.querySelectorAll('.page-search').forEach(function(li) {
      const content = li.getAttribute('data-page-content')?.toLowerCase() || '';

      if (content.includes(term)) {
        console.log(content);
        li.style.setProperty('display', 'list-item', 'important');
        li.style.display = 'block'; // Show matching li
      } else {
         console.log('not found');
        li.style.setProperty('display', 'none', 'important');
        li.style.display = 'none'; // Hide non-matching li
      }
    });
  }

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    console.log(newSearchTerm);
     // filterPages(newSearchTerm);
    
    setTimeout(function(){
     filterPages(newSearchTerm);
    },1400);
    
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.showDefaultSuggestions();
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
      // alert('clear');
      const el = document.querySelector('.icon_search_mob');
      if (el) {
      el.style.display = 'block';
      }
    }
     const currentSearchTerm = this.getQuery();

      if (!currentSearchTerm.length) {
      this.showDefaultSuggestions();
      return;
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) {
      this.showDefaultSuggestions();
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if(this){
if (!this.contains(document.activeElement)) this.close();
      }
      
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) {
      this.showDefaultSuggestions();
    }
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) return;
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
    const el = document.querySelector('.icon_search_mob');
    if (el) {
    el.style.display = 'none';
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) return;
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(
      this.querySelector('[data-predictive-search-live-region-count-value]')?.textContent || ''
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
     document.querySelectorAll('.child-drawer.active').forEach(el => {
        el.classList.remove('active');
      });
        console.log('clicked');
      document.addEventListener('click', (e) => {
    const clickedTab = e.target.closest('.mobile_search_tabs .predictive-search__heading');
    console.log('clicked 12');
    if (document.body.classList.contains('overflow-hidden-tablet')) {
            document.body.classList.remove('overflow-hidden-tablet');
          }
    if (clickedTab) {
   
    // Remove active class from all buttons and contents
    document.querySelectorAll('.mobile_search_tabs .predictive-search__heading').forEach(btn => {
      btn.classList.remove('active');
    });

    document.querySelectorAll('.tab_search_content').forEach(content => {
      content.classList.remove('active');
    });

    // Add active class to clicked button and related content
    clickedTab.classList.add('active');
    const tabId = clickedTab.getAttribute('data-tab');
    document.getElementById(tabId)?.classList.add('active');
  }
});

 const element = document.getElementById('predictive-search-pages-desktop');
  if (element) {
    element.classList.add('your-class-name'); // Replace with the class you want to add
  }
  document.addEventListener('click', (event) => {
  // Check if the clicked element or its ancestor is the dynamic element
  const dynamicElement = event.target.closest('your-class-name');
  if (dynamicElement) {
    alert('open');
    dynamicElement.classList.add('your-class-name-12'); // Replace with your desired class
  }
   });

  }

  // close(clearSearchTerm = false) {
  //   this.closeResults(clearSearchTerm);
  //   this.isOpen = false;
  // }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    // console.log('removed popup');
    const searchDetails = document.querySelector('.header__search details');
    if (searchDetails && searchDetails.hasAttribute('open')) {
    searchDetails.removeAttribute('open');
    }
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }

  showDefaultSuggestions() {
    const defaultSection = document.getElementById('DefaultSearchProducts');
    if (!defaultSection) return;

    this.predictiveSearchResults.innerHTML = defaultSection.innerHTML;
    this.setAttribute('results', true);
    this.open();
  }
}

customElements.define('predictive-search', PredictiveSearch);

// document.addEventListener('click', (event) => {
//   const button = event.target.closest('.predictive-search__suggestion-btn');

//   if (button) {
//      event.preventDefault();
//     const searchTerm = button.getAttribute('data-suggestion');
//     const searchInput = document.querySelector('predictive-search input[name="q"]');

//     if (searchInput && searchTerm) {
//       searchInput.value = searchTerm;

//       // Focus the input
//       searchInput.focus();

//       // Trigger the input event
//       const inputEvent = new Event('input', {
//         bubbles: true,
//         cancelable: true,
//       });
//       searchInput.dispatchEvent(inputEvent);

//       // Optional: simulate keyup to further engage predictive search
//       const keyupEvent = new KeyboardEvent('keyup', {
//         bubbles: true,
//         cancelable: true,
//         key: 'a',
//         keyCode: 65,
//       });
//       searchInput.dispatchEvent(keyupEvent);
//     }
//   }
// });

document.addEventListener('click', (e) => {
  const clickedTab = e.target.closest('.mobile_search_tabs .predictive-search__heading');
  
  if (clickedTab) {
    // Remove active class from all buttons and contents
    document.querySelectorAll('.mobile_search_tabs .predictive-search__heading').forEach(btn => {
      btn.classList.remove('active');
    });

    document.querySelectorAll('.tab_search_content').forEach(content => {
      content.classList.remove('active');
    });

    // Add active class to clicked button and related content
    clickedTab.classList.add('active');
    const tabId = clickedTab.getAttribute('data-tab');
    document.getElementById(tabId)?.classList.add('active');
  }
});


document.addEventListener('DOMContentLoaded', () => {
  // document.addEventListener('click', (e) => {
  //   // Check if click is on .modal-overlay inside an open details in .header__search
  //   const overlay = e.target.closest('.modal-overlay');
  //   alert('test');
  //   if (!overlay) return;
    
  //   // Check if overlay is inside a details[open] and .header__search
  //   const details = overlay.closest('details[open]');
  //   const headerSearch = overlay.closest('.header__search');

  //   if (details && headerSearch) {
  //     // Remove open attribute to close the details
  //     details.removeAttribute('open');
  //   }
  // });
});

// document.addEventListener('DOMContentLoaded', function() {
//   const desktopSearch = document.getElementById('predictive-search-pages-desktop');
//   if (desktopSearch) {
//     desktopSearch.addEventListener('click', function() {
//       alert('open');
//       desktopSearch.classList.add('your-class-name'); // replace 'your-class-name' with the class you want to add
//     });
//   }
// });
